// extracted by mini-css-extract-plugin
module.exports = {"searchEmpty":"style_searchEmpty__wnGYB","img":"style_img__LYKZZ"};